import Vue from 'vue'
import VueResize from 'vue-resize'
import VueCompositionAPI from '@vue/composition-api'
import 'vue-resize/dist/vue-resize.css'

Vue.use(VueCompositionAPI)
Vue.use(VueResize)
